import VendorListCard from "./VendorListCard";

export default function VendorListCardGrid({
  lists = [],
  newlyCreatedListId = null,
  onEditModeEntered,
  onOpenList,
  onRenameList,
  onDuplicateList,
  onDeleteList,
  onExportCsv,
  onExportExcel,
}) {
  if (!lists.length) return null;

  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {lists.map((list) => (
        <VendorListCard
          key={list.id}
          list={list}
          isNewlyCreated={list.id === newlyCreatedListId}
          onEditModeEntered={onEditModeEntered}
          onOpen={onOpenList}
          onRename={onRenameList}
          onDuplicate={onDuplicateList}
          onDelete={onDeleteList}
          onExportCsv={onExportCsv}
          onExportExcel={onExportExcel}
        />
      ))}
    </div>
  );
}
